import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { List } from "../../../framework/List/List";
import { PanelTitle } from "../../../framework/Panel/PanelTitle";
import { Box } from "@mui/material";
import { TTaskTypeUnitGroup } from "source/models/taskType/taskTypeUnitGroup";

interface ITaskTypesByUnitsDialogTableProp {
    group: TTaskTypeUnitGroup;
    parentName: string;
}

export const TaskTypesByUnitsDialogTable = (props: ITaskTypesByUnitsDialogTableProp) => {
    if (!props.group) return null;
    const unitTitle = Translations.Unit + ": " + (props.parentName ? props.parentName + " / " : "") + props.group.name;
    const taskTypes = props.group.taskTypes;
    return (
        <Box>
            {taskTypes.length > 0 &&
                <Box display="flex" flexDirection="column" sx={{ marginBottom: "1.5rem" }}>
                    <PanelTitle title={unitTitle} />
                    <List
                        intialized={true}
                        isLoading={false}
                        hasMore={false}
                        header={{
                            columns: [
                                { size: 4, column: "code", content: Translations.TaskType },
                                { size: 8, column: "comment", content: Translations.Description },
                            ]
                        }}
                        lines={
                            taskTypes.map((taskType) => {
                                return {
                                    columns: [
                                        { size: 4, content: taskType.code },
                                        { size: 8, content: taskType.comment },
                                    ],
                                    id: taskType.id
                                };
                            })
                        }
                        sortColumn={""}
                        sortOrderIsAsc={true}
                        selectedId={""}
                        onSetSelectedIds={null}
                        onSearchLines={null}
                    />
                </Box>
            }
            {props.group.children.map((childGroup) =>
                <TaskTypesByUnitsDialogTable
                    key={childGroup.id}
                    group={childGroup}
                    parentName={props.group.name}
                />
            )}
        </Box>
    );
};